import { ReactNode } from 'react';
import { PageContainer } from '@/components/containers/page-container';
import { Section } from '@/components/containers/section';
import { GradientFormTitle } from '@/components/containers/gradient-form-title';
import { VisitTitleButtons } from '@/components/navigation/visit-title-buttons';
import { useMediaQuery } from '@/hooks/use-media-query';
import styles from './simple-visit-page-container.module.css';
import { SaveProgressButton } from './navigation/save-progress-button';

interface SimpleVisitPageContainerProps {
  icon: ReactNode;
  title: string;
  body: ReactNode;
  buttonContainer: ReactNode;
}

export function SimpleVisitPageContainer({
  icon,
  title,
  body,
  buttonContainer,
}: SimpleVisitPageContainerProps) {
  const isMobile = useMediaQuery('--screen-md');

  return (
    <PageContainer>
      {isMobile ? (
        <GradientFormTitle>
          <VisitTitleButtons
            saveProgress={{ showModal: true }}
            className={styles.visitTitleButtons}
          />
          <SaveProgressButton className={styles.saveProgressButton} showModal />
        </GradientFormTitle>
      ) : (
        <VisitTitleButtons saveProgress={{ showModal: true }} />
      )}
      <Section isFormSection={false} className={styles.section}>
        {icon}
        <div className={styles.bodyContainer}>
          <h1 className="h3">{title}</h1>
          {body}
        </div>
        {buttonContainer}
      </Section>
    </PageContainer>
  );
}
